import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ERoleAdminString } from '../../shared/data/role.enum';
import { IFilterReasons, IReason } from './data/reason'
import { ManagerReasonService } from './services/manager-reason.service'

@Component({
  selector: 'app-reasons',
  templateUrl: './reasons.component.html',
  styleUrls: ['./reasons.component.scss']
})
export class ReasonsComponent implements OnInit {
  ERoleAdminString = ERoleAdminString;
  reasons: IReason[] = [];
  dadosPaginacao = {
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  formInput = new UntypedFormControl();

  constructor(
    private readonly managerReasonService: ManagerReasonService
  ) {}

  ngOnInit(): void {
    this.listReasons()
  }

  listReasons(): void {
    const filter: IFilterReasons = {
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina)
    }

    if (this.formInput.value) {
      filter.searchText = this.formInput.value;
    }

    this.managerReasonService.getAttendanceReports(filter).subscribe(response => {
      this.reasons = response.data;
      this.dadosPaginacao.totalPaginas = Math.ceil(response.count! / this.dadosPaginacao.tamanhoPagina);
      this.dadosPaginacao.itensTotal = response.count!
    });
  }

  public cleanForm(): void {
    this.formInput.reset()
    this.listReasons()
  }

  public mudouTamanhoPagina(itensPaginaSelecionada: number): void {
    this.dadosPaginacao.tamanhoPagina = itensPaginaSelecionada;
    this.listReasons()
  }

  public mudouPagina(paginaSelecionada: number): void {
    this.dadosPaginacao.paginaSelecionada = paginaSelecionada;
    this.listReasons()
  }
}
